/* ==================================================
   WWC Home JS
   Loaded only on homepage
================================================== */

(function () {
  function initHomeMarquee() {
    var marquees = document.querySelectorAll('[data-wwc-home-marquee]');
    if (!marquees.length) return;

    marquees.forEach(function (root) {
      if (root.dataset.inited === '1') return;
      root.dataset.inited = '1';

      var track = root.querySelector('[data-wwc-marquee-track]');
      if (!track || !track.parentNode) return;

      var clones = Number(root.dataset.clones || 3);
      if (!Number.isFinite(clones) || clones < 1) clones = 3;

      for (var i = 0; i < clones; i += 1) {
        var clone = track.cloneNode(true);
        clone.removeAttribute('data-wwc-marquee-track');
        clone.setAttribute('aria-hidden', 'true');
        track.parentNode.appendChild(clone);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeMarquee);
  } else {
    initHomeMarquee();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHomeMarquee);
  }
})();